<template>
<div class="custom-header" ref="custom-header">
  <van-nav-bar
  :title="title"
  left-text=""
  left-arrow
  @click-left="onClickLeft"
/>
</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default:''
    },

  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  computed: {
    
  },
  methods: {
    onClickLeft(){
        this.$router.back()
    },
  },
  watch: {
    $route(newval, oldval) {
      console.log("this.$store.state", newval, oldval, this.$store.state.headerActive);
      if (newval.name == 'index' || newval.name == 'train' || newval.name == 'lesson' || newval.name == 'live' || newval.name == 'media' || newval.name == 'media') {
        this.$store.commit("SET_HEADER", newval.name);
      }
      this.$store.commit("SET_HEADER_HEIGHT", this.$refs['custom-header'].offsetHeight);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .van-nav-bar{
    background-color: transparent;
    .van-icon{
      color: #FFFFFF;
    }
  }
  ::v-deep .van-hairline--bottom::after{
    border: 0;
  }
  ::v-deep .van-nav-bar__title{
    color: #FFFFFF;
  }
</style>>
